import i18n from 'i18next';
import { useSetAtom } from 'jotai';
import { useLocation } from 'react-router-dom';
import { useEffect, useCallback } from 'react';

import localStorageUtil from 'src/utils/localStorageUtil';

import store from 'src/store';
import boardApi from 'src/api/boardApi';
import inboxApi from 'src/api/inboxApi';
import { getDefaultLanguage } from 'src/i18n';
import { inboxListCountAtom } from 'src/store/inbox';
import { communityDataAtom, socialLearningDataAtom } from 'src/store/board';

// 로그인 관련 페이지에서는 fetchData 실행하지 않음
const skipPaths = ['/', '/login'];

const useRouteHandler = () => {
  const location = useLocation();
  const shouldSkipFetchData = skipPaths.includes(location.pathname);

  const setInboxListCount = useSetAtom(inboxListCountAtom);
  const setSocialLearningData = useSetAtom(socialLearningDataAtom);
  const setCommunityData = useSetAtom(communityDataAtom);
  const setInboxList = useSetAtom(store.inbox.inboxList);

  const token = localStorageUtil.getToken();

  const fetchData = useCallback(async () => {
    const brandCode = localStorageUtil.getBrandCode();
    await getDefaultLanguage(brandCode);

    const [socialResponse, communityResponse, inboxResponse] = await Promise.all([
      boardApi.socialList(),
      boardApi.communityList(),
      inboxApi.inboxList({ read: false }).then((res) => res),
    ]);

    const socialData = socialResponse?.data?.data ?? [];
    const communityData = communityResponse?.data?.data ?? [];
    const inboxData = inboxResponse?.data?.data ?? {};

    const socialAuthData = Array.isArray(socialData)
      ? socialData.filter((board: any) => board.boardAuth)
      : [];

    const communityAuthData = Array.isArray(communityData)
      ? communityData.filter((board: any) => board.boardAuth)
      : [];

    const inboxCount = inboxData?.totalElements ?? 0;
    const inboxList = inboxData;

    setSocialLearningData(socialAuthData);
    setCommunityData(communityAuthData);
    setInboxList(inboxList);

    if (inboxCount) {
      setInboxListCount(inboxCount);
    }
  }, [setSocialLearningData, setCommunityData, setInboxListCount, setInboxList]);

  useEffect(() => {
    if (token && !shouldSkipFetchData) {
      fetchData();
    }
  }, [token, location.pathname, fetchData, shouldSkipFetchData]);

  // 라우터 이동시 언어팩 있는지 확인하는 코드
  useEffect(() => {
    const handleFailedLoading = (lang: any, nameSpace: any, message: any) => {
      console.error(`언어팩 확인 : 언어(${lang}), 네임스페이스(${nameSpace}), 메시지: ${message}`);
    };

    i18n.on('failedLoading', handleFailedLoading);

    return () => {
      i18n.off('failedLoading', handleFailedLoading); // 이벤트 리스너 해제
    };
  }, []);
};

export default useRouteHandler;
